var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loanType=='salary_advance')?_c('SalaryAdvance',{attrs:{"customer":_vm.customer}}):(_vm.loanType=='check_me_back')?_c('CheckMeBack',{attrs:{"customer":_vm.customer}}):_c('LoanRequestType',{model:{value:(_vm.loanType),callback:function ($$v) {_vm.loanType=$$v},expression:"loanType"}})
}
var staticRenderFns = []

export { render, staticRenderFns }